import script from "./HeaderChatDialogsPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeaderChatDialogsPanel.vue?vue&type=script&setup=true&lang=ts"

import "./HeaderChatDialogsPanel.vue?vue&type=style&index=0&id=44e30f48&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44e30f48"]])

export default __exports__